import dayjs from 'dayjs';
export default class DateConverter {
  toQuery(defaultInfo, { fieldDetail, isRow }) {
    if (!fieldDetail.valueOfFilter) {
      return { ...defaultInfo, value: 'year' };
    }
    const valueOfFilter = JSON.parse(fieldDetail.valueOfFilter);
    if (isRow) {
      return { ...defaultInfo, value: valueOfFilter.fixedValue || 'year' };
    }

    const dateRange = valueOfFilter.rangeValue || [];
    const dateQuery = { ...defaultInfo, agg_type: 'date', value: 'year' };
    if (!dateRange[0] && !dateRange[1]) {
      return dateQuery;
    }
    dateQuery.filter = { must: [{ range: { [fieldDetail.columnKey]: {} } }] };
    if (dateRange[0]) {
      const gteDate = dayjs(valueOfFilter.rangeValue[0]).valueOf();
      dateQuery.filter.must[0].range[fieldDetail.columnKey].gte = gteDate;
    }
    if (dateRange[1]) {
      const ltDate = dayjs(valueOfFilter.rangeValue[1])
        .add(1, 'day')
        .valueOf();
      dateQuery.filter.must[0].range[fieldDetail.columnKey].lt = ltDate;
    }
    return dateQuery;
  }

  toFrontEndVal({ fieldItem, isRow }) {
    if (isRow) {
      return JSON.stringify({ fixedValue: fieldItem.value || 'year' });
    }
    const rangeValue = [];
    if (fieldItem.filter) {
      const rangeInfo = fieldItem.filter.must[0].range[fieldItem.field];
      if (rangeInfo.gte) {
        rangeValue[0] = dayjs(rangeInfo.gte);
      }
      if (rangeInfo.lt) {
        rangeValue[1] = dayjs(rangeInfo.lt).subtract(1, 'day');
      }
    }
    return JSON.stringify({ fixedValue: fieldItem.value || 'year', rangeValue });
  }
}
